import { render } from "./DashboardView.vue?vue&type=template&id=62bc5ba2&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"

import "./DashboardView.vue?vue&type=style&index=0&id=62bc5ba2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\Bod_registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bc5ba2"]])

export default __exports__